module.exports = __webpack_public_path__ + "static/media/exit-arrow.cbdfc720.svg";